import { authApiService } from '@/api/authApiService';
import { ApiResponseType, RequestOptions } from '@/types/sharedTypes';
import { InvoiceCheckType } from '@/types/invoiceVaultTypes';
import { RequestAudienceType, RequestExpiryType, RequestTypeType, RequestViaType } from '@/types/vendorVaultTypes';

export type CreateInvoiceCheckPayloadType = {
  vendor_name: string;
  vendor_contact: string;
  via: RequestViaType;
  invoice_number: string;
  amount: string;
  currency: string;
  request_type: RequestTypeType;
  bank: string | null; // intl only
  detailed: boolean; // intl only
  mode: 'request' | 'verify';
  audience: RequestAudienceType;
  expiry_code: RequestExpiryType;
  wire_confirmation: boolean;
  bank_name_on_invoice: string;
  account_number_on_invoice: string;
  routing_on_invoice: string;
  invoice_file_key: string;
  invoice_file_name: string;
};

export const createInvoiceCheckApi = (
  payload: CreateInvoiceCheckPayloadType,
  options?: RequestOptions
): Promise<ApiResponseType<InvoiceCheckType>> => {
  return authApiService.POST('/invoice-vault/checks/', payload, null, options);
};
